const defaultConfig = {
  enableColResize: true,
  defaultColDef: {
    editable: false,
    suppressToolPannel: true,
    suppressMenu: true,
    suppressFilter: true,
    suppressResize: false,
    suppressNavigable: false,
    minWidth: 100,
  },
  suppressDragLeaveHidesColumns: true,
  suppressMultiSort: true,
  suppressCellSelection: true,
  suppressColumnVirtualisation: true,
  enableSorting: true,
  enableFilter: false,
  headerHeight: 50,
  deltaRowDataMode: true,
  // Ideally something better than JSON.stringify, we have a complex sortId
  getRowNodeId: ({ id, sortId }) => (sortId && JSON.stringify(sortId)) || id,
  rowHeight: 30,
  megaRowHeight: 52,
  rowBuffer: 99999,
  isFullWidthCell: ({ data: { full } }) => full,
  getRowHeight: ({ data: { full, hasMega = false } }) => {
    if (full && hasMega) {
      return defaultConfig.rowHeight;
    } else if (full && !hasMega) {
      return defaultConfig.megaRowHeight;
    }
    return defaultConfig.rowHeight;
  },
  context: {
    store: () => window.appJs.store,
  },
};

export const helpText = 'For Notes, Sources, and Definitions please click on the "Notes" link associated with each indicator title.';

export const moreInfoHTML = '<a href="https://www.kff.org/about-state-health-facts/" target="_blank">Learn more about Custom State Reports</a> including how to properly cite the data.';

export default defaultConfig;



// WEBPACK FOOTER //
// ./app/config/tableConfig.js